var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useMemo } from 'react';
import { Box, LayoutContent, LayoutContentBody, LayoutControls, ContentFrame, Button, Typography, ScreenContainer, } from '@pinwheel/origami';
import ModalHeader from '../../components/ModalHeader';
import useLinkNavigate from '../../hooks/useLinkNavigate';
import { useGetLocalizedString } from '../../hooks/useGetLocalizedString';
var HelpSection = function (_a) {
    var title = _a.title, content = _a.content;
    return (React.createElement(Box, null,
        React.createElement(Typography, { variant: "label", color: "title" }, title),
        React.createElement(Typography, { variant: "caption" }, content)));
};
export default function MultiSupplierLookup() {
    var navigate = useLinkNavigate();
    var getLocalizedString = useGetLocalizedString();
    var helpSections = useMemo(function () { return [
        {
            key: '1',
            title: getLocalizedString('MS_ELIGIBILITY_HELP_SECTION_1_TITLE'),
            content: getLocalizedString('MS_ELIGIBILITY_HELP_SECTION_1_CONTENT'),
        },
        {
            key: '2',
            title: getLocalizedString('MS_ELIGIBILITY_HELP_SECTION_2_TITLE'),
            content: getLocalizedString('MS_ELIGIBILITY_HELP_SECTION_2_CONTENT'),
        },
    ]; }, [getLocalizedString]);
    return (React.createElement(ScreenContainer, { "data-testid": "mse-help" },
        React.createElement(ModalHeader, null),
        React.createElement(ContentFrame, null,
            React.createElement(LayoutContent, null,
                React.createElement(LayoutContentBody, null, helpSections.map(function (section) { return (React.createElement(HelpSection, __assign({}, section))); }))),
            React.createElement(LayoutControls, null,
                React.createElement(Button, { onClick: function () { return navigate(-1); } }, getLocalizedString('MS_ELIGIBILITY_HELP_SUBMIT'))))));
}
